const { ccclass } = cc._decorator;
import ModuleBase, { ViewLayer, bindButtonClickEvent, moduleInit } from "../../../framework/core/mvvm/module_base";
import AppData from "../../public/const/app_data";
import ModelData from '../../public/model_data';
import ModuleManager from "../../../framework/core/module_manager";
import ClubListView from "./clubList_view";
import ClubHallModule from "../hall/club_hall_module";
import DialogTips from "../../public/module/dialog_tips/dialog_tips";
import ClubPromotion from "../promotion/club_promotion";
import SceneManager from "../../../manager/scene_manager";
import LoaclStorage from "../../../manager/local_storage";
import AudioManager from "../../../manager/audio_manager";
import { club_utils } from "../club_utils";

@ccclass
@moduleInit("ClubList")
export default class ClubList extends ModuleBase<ClubListView, null>  {
    inPutRoomNumber = ""
    clubListData = null
    isBack = false //是否由俱乐部返回的
    constructor() {
        super()
        this.layer = ViewLayer.Mid;
        this.windowPrefabResPath = 'package/club/module/clubListPanel';       
        this.viewType = ClubListView;
        this.needDeferShow = true
    }

    protected onDeferShow(intentData) {
        this.isBack = intentData
        this.getClubListData()
    }

    onInit(){
        this.bindEvent();
    }


    protected onButtonClickName(name : string) {
        switch (name) {
            case "BackBtn":
                let self = this;
                SceneManager.lastEntranceOpenModuleName = ""
                SceneManager.showHall("OpenFromClub", () => {
                    self.hide()
                    LoaclStorage.setNumber("__lastEnterClubId", 0)
                })
                break;
            case "CreatBtn":
                let str = "1，俱乐部是玩家们进行高端竞技的私人场所\n2,目前该功能正在公测\n3，联系客服创建俱乐部，客服LINE123123"
                ModuleManager.instance.showModule(DialogTips, { Content: str})
                break;
            case "CheXiaoBtn":
                this.inPutRoomNumber = this.inPutRoomNumber.substring(0,this.inPutRoomNumber.length - 1);
                this.view.updateShowInPut(this.inPutRoomNumber)
                break;
            case "ChonZhiBtn":
                this.inPutRoomNumber = ""
                this.view.updateShowInPut(this.inPutRoomNumber)
                break;
            case "LeftBtn":
                this.view.moveButton("left")
                break
            case "RightBtn":
                this.view.moveButton("right")
                break
            default:
                break;
        }
    }

    protected onButtonClick(obj: cc.Node) {
        if (obj.parent.name == "NumberNode") {
            let nowNumber = Number(obj.name)
            if (this.inPutRoomNumber.length >= 4){
                this.inPutRoomNumber = this.inPutRoomNumber.substring(0,this.inPutRoomNumber.length - 1);
            }
            this.inPutRoomNumber = this.inPutRoomNumber + "" + nowNumber
            this.view.updateShowInPut(this.inPutRoomNumber)
            if (this.inPutRoomNumber.length >= 4){
                this.applyJoin(this.inPutRoomNumber)
            }
        }

    }

    //获取俱乐部列表数据
    getClubListData(clubCode = null){
        let self = this
        // let requestData: IHttpRequestData = {
        //     baseUrl: "club/user/getGameUserClubList?",
        //     params: {
        //         gameUserId: ModelData.instance.roleData.id,
        //     },
        //     showNetPrompt:true
        // }

        club_utils.reqClubList(this,(data)=>{

            self.clubListData = data
            let m_Data = data
            if (clubCode != null){
                
                for (let index = 0; index < m_Data.length; index++) {
                    if (clubCode == m_Data[index].clubNum){
                        self.enterClubView(m_Data[index], true)
                    }
                }
            }
            else{
                if  (m_Data.length == 1 && !self.isBack){
                    self.enterClubView(m_Data[0])
                }
                else{
                    self.show()  
                }
               
                self.view.updateShow(data, LoaclStorage.getNumber("__lastEnterClubId"))//更新数据
            }
        });

        // this.apiHttpGet(requestData, (respone) => {
        //     self.clubListData = respone.data
        //     let m_Data = respone.data
        //     if (clubCode != null){
                
        //         for (let index = 0; index < m_Data.length; index++) {
        //             if (clubCode == m_Data[index].clubNum){
        //                 self.enterClubView(m_Data[index], true)
        //             }
        //         }
        //     }
        //     else{
        //         if  (m_Data.length == 1 && !self.isBack){
        //             self.enterClubView(m_Data[0])
        //         }
        //         else{
        //             self.show()  
        //         }
               
        //         self.view.updateShow(respone.data, LoaclStorage.getNumber("__lastEnterClubId"))//更新数据
        //     }
        // })

    }

    onShow(){

        AudioManager.instance.stopMusic();
    }

    //进入俱乐部
    enterClubView(data, isNew = false){
        SceneManager.gotoClubHall(data)        
    }

    //申请进入俱乐部
    applyJoin(clubCode){
        if (clubCode.length <= 0){
            return
        }
        let self = this
        let requestData: IHttpRequestData = {
            baseUrl: "club/user/applyJoin?",
            params: {
                gameUserId: ModelData.instance.roleData.id,
                clubNum:clubCode,
            },
            showNetPrompt:true
        }
        this.apiHttpGet(requestData, (respone) => {
            self.inPutRoomNumber = ""
            self.view.updateShowInPut(self.inPutRoomNumber)
            self.getClubListData(clubCode)
            // LoaclStorage.setNumber("AUTO_JOIN_CLUB_ID", clubCode, true)
        })
    }  

    bindEvent(){
        this.eventBind("IN_CLUB_EVENT",this.enterClubView)
    }
}